import axios from 'lib/axios'

export interface RenewalRequestEmail {
  mail: string
  type: 'inventory_renewal_request'
  company: string
  inventoryName: string
  inventoryStatus: string
  availableCredits: string | number
  usedCredits: string | number
  expirationDate: string
  message: string
}

export const requestRenewalEmail = async (payload: RenewalRequestEmail) => {
  const response = await axios.post('/email/send', [payload])
  return response.data
}
